export const REGISTER_FIELD_CHANGE = 'CLIENTS_BASIC_INFO/REGISTER_FIELD_CHANGE';
export const SET_FIELD_VALIDATION = 'CLIENTS_BASIC_INFO/SET_FIELD_VALIDATION';
export const SET_BASIC_INFO = 'CLIENTS_BASIC_INFO/SET_BASIC_INFO';
export const SET_CLIENT_ID = 'CLIENTS_BASIC_INFO/SET_CLIENT_ID';
export const SET_ADDRESS = 'CLIENTS_BASIC_INFO/SET_ADDRESS';
export const CLEAR_ADDRESS = 'CLIENTS_BASIC_INFO/CLEAR_ADDRESS';
export const CLEAR_BASIC_INFORMATION = 'CLIENTS_BASIC_INFO/CLEAR_BASIC_INFORMATION';
export const HANDLE_POSTAL_CODE = 'CLIENTS_BASIC_INFO/HANDLE_POSTAL_CODE';
export const HANDLE_LOADING = 'CLIENTS_BASIC_INFO/HANDLE_LOADING';
export const SET_IS_EDIT = 'CLIENTS_BASIC_INFO/SET_ID_EDIT';